var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container-contracts",attrs:{"data-anima":"top"}},[_c(_setup.contractDetailsHeader),_c(_setup.contractDetails),_c(_setup.contractDetailsInstallment),_c(_setup.contractDetailsClient)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }